var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.lazy || _vm.loaded || _vm.active)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"sj-tab-pane",class:{ border: _vm.border }},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }